import { useState } from "react";
import {
  ResponseGetWarehouseResponse,
  WarehousesApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetWarehouses = () => {
  const [warehousesList, setWarehousesList] = useState<
    ResponseGetWarehouseResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchWarehouses = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();

      const api = new WarehousesApi(config);
      const response = await api.warehousesGetAllGet();
      setWarehousesList(response);
      return response;
    } catch (err) {
      setError("倉庫一覧の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { warehousesList, fetchWarehouses, error, isLoading };
};
